import { ElementOptions } from '@/models/survey-elements/element-options';
import { Expose, Type } from 'class-transformer';

export class SurveyMultipleSelectOptions extends ElementOptions {
  @Expose()
  value!: number;

  @Expose()
  allowCustomValue!: boolean;

  @Expose()
  customValue!: string | null;
}

export class MultipleSelectProps {
  @Expose()
  title?: string;
  @Expose()
  maxAllowedOptionsNumber!: number | null;

  @Expose()
  externalApiIdentifier!: string | null;

  @Expose()
  externalPreselectionMode!: string;

  @Expose()
  externalPreselectionQuestion!: string;

  @Expose()
  hasExternalPreselection!: boolean;

  @Expose()
  preselectedValues!: number[];

  @Expose()
  preselectedCustomValues!: string[];

  @Expose()
  @Type(() => SurveyMultipleSelectOptions)
  options!: SurveyMultipleSelectOptions[];

  @Expose()
  value!: SurveyMultipleSelectOptions[] | null;
}
